import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "24",
  fill: "none",
  viewBox: "0 0 20 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#032E32",
      d: "M10 20a2 2 0 0 0 2-2H8a2 2 0 0 0 2 2m0-14.082-.797.161A4 4 0 0 0 6 10c0 .628-.134 2.197-.459 3.742-.16.767-.376 1.566-.663 2.258h10.244c-.287-.692-.502-1.49-.663-2.258C14.134 12.197 14 10.628 14 10a4 4 0 0 0-3.203-3.92zM16.22 16c.223.447.482.801.78 1H3c.299-.199.557-.553.78-1C4.68 14.2 5 10.88 5 10c0-2.42 1.72-4.44 4.005-4.901a1 1 0 1 1 1.99 0A5 5 0 0 1 15 10c0 .88.32 4.2 1.22 6"
    }, null, -1)
  ])))
}
export default { render: render }